import { axiosInstance as axios, handleAxiosErrors } from '_utils';
import $ from 'jquery';
import { validate } from './field';
import { createAlert } from './window';
import config from '../store/_config';
import { buildFilterParams } from '../selectors/converterSelector';
import { create } from "./field--selectize";

let supplierList = [];
let registrationMemberType = typeof window.registrationType ? window.registrationType : '';
let requestTimeout = null;

export const combineDeliveryAddress = (addressData) => {
    var tmp = [];

    if (
        typeof addressData['DeliveryAddress[StreetNumber]'] != 'undefined' &&
        addressData['DeliveryAddress[StreetNumber]']
    ) {
        tmp.push(addressData['DeliveryAddress[StreetNumber]']);
    }
    if (
        typeof addressData['DeliveryAddress[StreetName]'] != 'undefined' &&
        addressData['DeliveryAddress[StreetName]']
    ) {
        tmp.push(addressData['DeliveryAddress[StreetName]']);
    }
    if (
        typeof addressData['DeliveryAddress[StreetSuffix]'] != 'undefined' &&
        addressData['DeliveryAddress[StreetSuffix]']
    ) {
        tmp.push(addressData['DeliveryAddress[StreetSuffix]']);
    }
    if (
        typeof addressData['DeliveryAddress[Suburb]'] != 'undefined' &&
        addressData['DeliveryAddress[Suburb]']
    ) {
        tmp.push(addressData['DeliveryAddress[Suburb]']);
    }
    if (
        typeof addressData['DeliveryAddress[State]'] != 'undefined' ||
        typeof addressData['DeliveryAddress[PostalCode]'] != 'undefined'
    ) {
        var statePostcode = '';

        if (
            typeof addressData['DeliveryAddress[State]'] != 'undefined' &&
            addressData['DeliveryAddress[State]']
        ) {
            statePostcode += ` ${addressData['DeliveryAddress[State]']} `;
        }
        if (
            typeof addressData['DeliveryAddress[PostalCode]'] != 'undefined' &&
            addressData['DeliveryAddress[PostalCode]']
        ) {
            statePostcode += ` ${addressData['DeliveryAddress[PostalCode]']} `;
        }

        statePostcode = statePostcode.trim();
        if (statePostcode) {
            tmp.push(statePostcode);
        }
    }
    if (
        typeof addressData['DeliveryAddress[Country]'] != 'undefined' &&
        addressData['DeliveryAddress[Country]']
    ) {
        tmp.push(addressData['DeliveryAddress[Country]']);
    }

    return tmp.join(', ');
};
export const requestSupplierData = ($el) => {
    if (registrationMemberType == '') {
        console.error('Registration Type does not exist');
    }

    var $form = $el.closest('.form'),
        url = config.registration.supplierList.url,
        query = config.registration.supplierList.query,
        $supplierField = $form.find('[data-supplier-select]'),
        $supplierFieldLabel = $supplierField.closest('.field'),
        $supplierSelectizeField = $supplierField.length ? $supplierField[0].selectize : null,
        $addressFields = $form.find('[data-registration="address"]'),
        addressData = {},
        requiredAddressFieldsFilled = true,
        params = {
            Address: '',
            MemberType: registrationMemberType,
        };

    if (!$supplierField.length) {
        return;
    }

    $addressFields.each(function () {
        var $input = $(this);

        if (!validate($input)) {
            requiredAddressFieldsFilled = false;
        }

        addressData[$input.attr('name')] = $input.val();
    });

    if (requiredAddressFieldsFilled) {
        params.Address = combineDeliveryAddress(addressData);

        console.log('params', params);

        // Start requesting
        query = query.replace('{params}', buildFilterParams(params));

        requestTimeout = setTimeout(function () {
            return axios
                .get(url, {
                    withCredentials: true,
                    params: {
                        query: query,
                    },
                })
                .then((response) => {
                    $supplierSelectizeField.clearOptions();

                    if (response.data.data.readMemberFilteredSuppliers) {
                        supplierList = response.data.data.readMemberFilteredSuppliers.map(
                            (item) => {
                                let displayedName = item.BusinessName || '';

                                if (displayedName == '' || displayedName == null) {
                                    displayedName = `${item.FirstName ? item.FirstName : ''
                                        } ${item.Surname ? item.Surname : ''}`.trim();
                                }

                                const supplierListItem = {
                                    ID: item.ID,
                                    Name: displayedName,
                                    BusinessAddress: item.BusinessAddress.FullAddress || '',
                                };

                                return supplierListItem;
                            }
                        );
                    } else {
                        supplierList = [];
                    }

                    console.log(supplierList);

                    $supplierSelectizeField.addOption(supplierList);
                    $supplierSelectizeField.refreshOptions(false);
                    // $supplierSelectizeField.refreshOptions(true);
                    $supplierSelectizeField.enable();
                    $supplierFieldLabel.removeClass('field--disabled');
                })
                .catch((error) => {
                    handleAxiosErrors(error);
                });
        }, 1000);
    } else {
        $supplierSelectizeField.disable();
        $supplierFieldLabel
            .addClass('field--disabled')
            .removeClass('field--focus');

        clearTimeout(requestTimeout);
        requestTimeout = null;
    }
};
export const getSupplierFromAddress = () => {
    return supplierList;
};
export const createSupplierSelect = ($el) => {
    const options = {
        maxItems: 1,
        searchField: ['Name', 'BusinessAddress'],
        searchConjunction: ['or'],
        render: {
            item: function (item, escape) {
                return `
                    <div class="field-selectize__display">
                        ${item.Name ? '<div class="field-selectize__title">' + escape(item.Name) + '</div>' : ''}
                        ${item.BusinessAddress ? '<div class="field-selectize__subtitle">' + escape(item.BusinessAddress) + '</div>' : ''}
                    </div>
                `;
            },
            option: function (item, escape) {
                return `
                    <div class="field-selectize__item">
                        ${item.Name ? '<div class="field-selectize__title">' + escape(item.Name) + '</div>' : ''}
                        ${item.BusinessAddress ? '<div class="field-selectize__subtitle">' + escape(item.BusinessAddress) + '</div>' : ''}
                    </div>
                `;
            }
        },
    };

    create($el, options);
};
export const binds = ($el, ignore) => {
    // ---------------- change filter
    $('[data-supplier-select]').each(function () {
        createSupplierSelect($(this));
    });

    const isBase64 = str => {
        try {
            return window.encodeJsonToBase64(window.decodeJsonFromBase64(str)) === str && str.length % 4 === 0;
        } catch {
            return false;
        }
    };

    const decodeBase64AndParseJSON = str => {
        try {
            const decoded = window.decodeJsonFromBase64(str);
            return JSON.parse(decoded);
        } catch (e) {
            console.error('Failed to decode base64 or parse JSON:', e);
            return null;
        }
    };

    const getDecodedData = () => {

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const encodedData = urlParams.get('reseller');

        if (encodedData && isBase64(encodedData)) {
            return decodeBase64AndParseJSON(encodedData);
        }

        return null;
    };

    const secondSlug = window.location.pathname.split('/')[2];

    const decodedData = getDecodedData();

    console.log("Decoded Data", decodedData)
    // $('#sheepCount').selectize({
    //     maxItems: 1,
    //     create: false,
    //     placeholder: 'Select sheep count',
    // });

    const sheepCountOptions = [
    { value: 'less_500', text: 'Less than 500' },
    { value: '500_1000', text: '500 - 1,000' },
    { value: '1000_2000', text: '1,000 - 2,000' },
    { value: '2000_3000', text: '2,000 - 3,000' },
    { value: '3000_5000', text: '3,000 - 5,000' },
    { value: '5000_10000', text: '5,000 - 10,000' },
    { value: '10000_20000', text: '10,000 - 20,000' },
    { value: '20000_more', text: '20,000 or more' }
];

const sheepSelect = $('#sheepCount').selectize({
    maxItems: 1,
    create: false,
    options: sheepCountOptions,
    placeholder: 'How many sheep do you have?'
})[0]?.selectize;
  sheepSelect?.setValue('less_500');
    const options = [
    { value: 'mixed_cropping_sheep', text: 'Mixed cropping + sheep' },
    { value: 'specialist_wool', text: 'Specialist wool' },
    { value: 'specialist_sheep_meat', text: 'Specialist sheep-meat (prime lamb)' },
    { value: 'stud_seed_stock_breeder', text: 'Stud / seed-stock breeder' },
    { value: 'small_scale_flocks', text: 'Small-scale & lifestyle flocks' },
    { value: 'mixed_sheep_cattle', text: 'Mixed sheep + cattle' },
    { value: 'mixed_sheep_goats', text: 'Mixed sheep + goats' },
    { value: 'mixed_sheep_other', text: 'Mixed sheep + other' },
    { value: 'feeding_operator', text: 'Finishing / feeding operator' },
    { value: 'emerging_niche', text: 'Emerging & niche' },
    { value: 'other', text: 'Other' },
];
 const selectizeInstance = $('#descriptionType').selectize({
        placeholder: 'What describes you best?',
        maxItems: 1,
        create: false,
        options: options,
        onChange: function (value) {
            console.log('User selected:', value);
        }
    })[0]?.selectize;



    // options.forEach(opt => {
    //     selectizeInstance?.addOption(opt);
    // });

    selectizeInstance?.setValue('mixed_sheep_cattle');



    if (secondSlug === 'register' && decodedData) {
        const { ID, BusinessName, BusinessAddress } = decodedData;
        console.log('Decoded ID:', ID);
        console.log('Decoded BusinessName:', BusinessName);

        $('[data-supplier-select]').each(function () {
            const selectize = $(this)[0].selectize;
            if (selectize) {
                const newOption = {
                    ID: ID,
                    Name: BusinessName,
                    BusinessAddress: BusinessAddress
                };
                selectize.addOption(newOption);
                selectize.addItem(ID);
                selectize.refreshOptions(false);
            }
        });

        return;
    }

    // ---------------- change filter
    $('body').on('change.registration', '[data-registration="address"]', function () {
        requestSupplierData($(this));
    });

};
$(document).ready(function () {
  // Delay to simulate loading; remove if not needed
  setTimeout(() => {
    $('.spa-form-loader').hide();
    $('.form-align-wrapper').fadeIn();
  }, 500); // adjust as needed
});